import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import GroupRoundedIcon from "@mui/icons-material/GroupRounded";
import CasinoRoundedIcon from "@mui/icons-material/CasinoRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import RedeemRoundedIcon from "@mui/icons-material/RedeemRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import GppGoodRoundedIcon from "@mui/icons-material/GppGoodRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import SpaceDashboardRoundedIcon from "@mui/icons-material/SpaceDashboardRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";

// Grouped navigation. Every route below maps to a real screen ported from
// casinoCoinAdminUI (plus the new MUI Dashboard at "/").
export const navGroups = [
  {
    items: [{ label: "Dashboard", path: "/", icon: DashboardRoundedIcon }],
  },
  {
    title: "Casino Dashboard",
    icon: SpaceDashboardRoundedIcon,
    items: [
      { label: "Overview", path: "/casino-dashboard" },
      { label: "Statistics", path: "/casino-dashboard/statistics" },
      { label: "Games", path: "/casino-dashboard/games" },
      { label: "Users", path: "/casino-dashboard/users" },
      { label: "Daily Transaction", path: "/casino-dashboard/daily-transactions" },
      { label: "Transactions", path: "/casino-dashboard/transactions" },
      { label: "WOF Transactions", path: "/casino-dashboard/wof-transactions" },
      { label: "All Transactions", path: "/casino-dashboard/all-transactions" },
    ],
  },
  {
    title: "Monitor",
    icon: InsightsRoundedIcon,
    items: [
      { label: "Overview", path: "/" },
      { label: "Games", path: "/monitor/games" },
      { label: "Revenue & P/L", path: "/monitor/revenue" },
      { label: "Acquisition", path: "/monitor/acquisition" },
      { label: "UTM Attribution", path: "/monitor/utm-attribution" },
      { label: "Analytics", path: "/monitor/analytics" },
      { label: "Retention", path: "/monitor/retention" },
      { label: "Payment Events", path: "/monitor/payment-events" },
      { label: "PWA Stats", path: "/monitor/pwa" },
    ],
  },
  {
    title: "Audience",
    icon: PeopleAltRoundedIcon,
    items: [
      { label: "Players 360", path: "/audience/players" },
      { label: "Segments", path: "/audience/segments" },
    ],
  },
  {
    title: "Players",
    icon: GroupRoundedIcon,
    items: [
      { label: "Users", path: "/UserList" },
      { label: "Blocked Domains", path: "/block-domain" },
      { label: "Action List", path: "/ActionList" },
      { label: "Access List", path: "/AccessList" },
    ],
  },
  {
    title: "Casino",
    icon: CasinoRoundedIcon,
    items: [
      { label: "Providers", path: "/provider" },
      { label: "Menu", path: "/menu" },
      { label: "Category", path: "/category" },
      { label: "Feature Games", path: "/featureGames" },
      { label: "Games", path: "/games" },
      { label: "Coin Package", path: "/coinPackage" },
      { label: "Promo", path: "/promo" },
      { label: "Gift Card", path: "/gift-card" },
    ],
  },
  {
    title: "Finance",
    icon: AccountBalanceWalletRoundedIcon,
    items: [
      { label: "Transfer", path: "/Transfer" },
      { label: "Payments", path: "/payments" },
      { label: "Withdrawals", path: "/withdrawals" },
      { label: "Redemption Claims", path: "/redemptionClaims" },
    ],
  },
  {
    // Single "Promotion" section. Every item below already existed elsewhere in
    // this menu and was moved here — same routes, same screens, no duplicates
    // left in Casino / Promotions / Engagement.
    title: "Promotion",
    icon: EmojiEventsRoundedIcon,
    items: [
      { label: "Monthly Promotions", path: "/monthly-promotions" },
      { label: "User Popup", path: "/MarketingPopup" },
      { label: "Streak Promotion Config", path: "/streak-types" },
      { label: "Pop-up Offers", path: "/popup-offers" },
      { label: "Promo Codes", path: "/promo-campaign" },
      { label: "Happy Hours", path: "/happy-hours" },
      { label: "Lottery", path: "/lottery" },
      { label: "Tournaments", path: "/tournaments" },
      { label: "Offer Post Page", path: "/offer-list" },
    ],
  },
  {
    title: "Promotions",
    icon: RedeemRoundedIcon,
    items: [
      { label: "Loyalty", path: "/loyalty" },
      { label: "Banner", path: "/Banner" },
      { label: "All Promotions", path: "/all-promotions" },
      { label: "Survey", path: "/survey" },
    ],
  },
  {
    // Single "Configuration" section. Every item below already existed elsewhere
    // in this menu and was moved here — same routes, same screens, no duplicates
    // left behind in Casino / Promotion / Promotions.
    //
    // "Configuration Page" (/config-list) is the existing screen that hosts the
    // row-based feature configs: Join Our Telegram Group (telegram_connect),
    // Share Rakeback Winnings (social_media), RakeBack (rakeback_enabled),
    // Daily Prize Run (daily_login_streak), Refer a Friend (refer_friend),
    // Birthday Bonus (birthday_bonus) and signup_bonus (signup_bouns). Those are
    // rows in the configurations table, not separate screens, so they are reached
    // through this one page rather than through their own menu entries.
    title: "Configuration",
    icon: SettingsRoundedIcon,
    items: [
      { label: "Configuration Page", path: "/config-list" },
      { label: "Wheel Of Fortune", path: "/wheel-of-fortune" },
      { label: "Mail In", path: "/mailIn-list" },
    ],
  },
  {
    title: "Operate",
    icon: GppGoodRoundedIcon,
    items: [
      { label: "Approvals", path: "/operate/approvals" },
      { label: "Risk & Fraud", path: "/operate/risk" },
      { label: "Marketing", path: "/operate/marketing" },
      { label: "Error Log", path: "/operate/error-log" },
      { label: "States", path: "/operate/states" },
    ],
  },
  {
    title: "Intelligence",
    icon: AutoAwesomeRoundedIcon,
    items: [
      { label: "AI Insights", path: "/intelligence/ai-insights" },
      { label: "Audit & Admin", path: "/intelligence/audit" },
    ],
  },
];
